import { gql } from '@apollo/client';

import PAYMENTS_FEE from './PAYMENTS_FEE';
import PAYMENTS_PRODUCT from './PAYMENTS_PRODUCT';

export default gql`
  fragment PaymentsLeg on Leg {
    ...PaymentsLegFields
    addOnLeg {
      ...PaymentsLegFields
    }
  }

  fragment PaymentsLegFields on Leg {
    id
    direction
    origin {
      name
    }
    destination {
      name
    }
    fees {
      ...PaymentsFee
    }
    timing {
      date
      isoDate
    }
    meals {
      code
      passenger {
        id
      }
    }
    cancelled
    products {
      ...PaymentsProduct
    }
    feeProducts {
      ...PaymentsProduct
    }
    extraProducts {
      ...PaymentsProduct
    }
    productSummaries @client {
      name
      passengerType
      code
      total
      quantity
      price
      currency
    }
    serviceType {
      code
    }
  }

  ${PAYMENTS_FEE}
  ${PAYMENTS_PRODUCT}
`;
